export const GET_LIST_MAU_IN = "GET_LIST_MAU_IN";
export const GET_LIST_MAU_IN_SUCCESS = "GET_LIST_MAU_IN_SUCCESS";
export const GET_LIST_MAU_IN_FAILURE = "GET_LIST_MAU_IN_FAILURE";

export const GET_NOI_DUNG_IN = "GET_NOI_DUNG_IN";
export const GET_NOI_DUNG_IN_SUCCESS = "GET_NOI_DUNG_IN_SUCCESS";
export const GET_NOI_DUNG_IN_FAILURE = "GET_NOI_DUNG_IN_FAILURE";
